import { FaArrowRight } from "react-icons/fa6"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import SideMenu from "../components/sideMenu/sideMenu"
import { Link, useLocation, useNavigate } from "react-router-dom"
import AcademicsLinks from "../components/academicCalendar/academicsLinks"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useMemo, useState } from "react"
import { fetchAcademicCalendarData } from "../redux/slice/academicCalendarPage"
import { retrunAssets } from "../utils/getAssets"
import { fetchAcademicCalendarItemsData } from "../redux/slice/academicCalendarItemsPage"

const AcademicCalendar = () => {

    const location = useLocation();
    const state = useSelector(state => state.academicCalendar)
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultActiveTab = parseInt(queryParams.get('sideTab')) || 0;

    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data == null) {
            dispatch(fetchAcademicCalendarData("academic-calendar"))

        }
    }, [state, dispatch])


    const academicCalendar = state?.data?.properties



    useEffect(() => {
        const activeTabFromQuery = parseInt(queryParams.get('sideTab')) || 0;
        setActiveTab(activeTabFromQuery);
    }, [queryParams]);

    useEffect(() => {
        
        if (academicCalendar?.content != null) {

            dispatch(fetchAcademicCalendarItemsData(academicCalendar?.content[activeTab]?.route?.path))
        }

    }, [academicCalendar, activeTab, dispatch])


    const text = academicCalendar?.title
    const bg = academicCalendar?.backgroundImage != null ? retrunAssets(academicCalendar?.backgroundImage[0]?.url) : ""
    const data = academicCalendar?.content?.map(item => {
        return {
            year: item?.name,
            link: item?.route?.path

        }
    })
    // const data = [
    //     {
    //         year: "Year 2022/2023",
    //         title: "Academic Year 2022/2023",
    //         description: "Please download the pdf below:",
    //         links: [
    //             {
    //                 name: "ACADEMIC CALENDAR YEAR 2023/2024 FOR UNDERGRADUATE & POSTGRADUATE (STRUCTURE B & C)",
    //                 url: "/assets/academicCalendar/2022-2023.pdf"
    //             },
    //             {
    //                 name: "ACADEMIC CALENDAR STRUCTURE A 2023/2024",
    //                 url: "/assets/academicCalendar/2022-2023.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 1 2023/2024 STRUCTURE A, B AND C COGS",
    //                 url: "/assets/academicCalendar/2022-2023.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 2 2023-2024",
    //                 url: "/assets/academicCalendar/2022-2023.pdf"
    //             },
    //         ]
    //     },
    //     {
    //         year: "Year 2023/2024",
    //         title: "Academic Year 2023/2024",
    //         description: "Please download the pdf below:",
    //         links: [
    //             {
    //                 name: "ACADEMIC CALENDAR YEAR 2023/2024 FOR UNDERGRADUATE & POSTGRADUATE (STRUCTURE B & C)",
    //                 url: "/assets/academicCalendar/2023-2024.pdf"
    //             },
    //             {
    //                 name: "ACADEMIC CALENDAR STRUCTURE A 2023/2024",
    //                 url: "/assets/academicCalendar/2023-2024.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 1 2023/2024 STRUCTURE A, B AND C COGS",
    //                 url: "/assets/academicCalendar/2023-2024.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 2 2023-2024",
    //                 url: "/assets/academicCalendar/2023-2024.pdf"
    //             },
    //         ]
    //     },
    //     {
    //         year: "Year 2024/2025",
    //         title: "Academic Year 2024/2025",
    //         description: "Please download the pdf below:",
    //         links: [
    //             {
    //                 name: "ACADEMIC CALENDAR YEAR 2024/2025 FOR UNDERGRADUATE & POSTGRADUATE (STRUCTURE B & C)",
    //                 url: "/assets/academicCalendar/2024-2025.pdf"
    //             },
    //             {
    //                 name: "ACADEMIC CALENDAR STRUCTURE A 2024/2025",
    //                 url: "/assets/academicCalendar/2024-2025.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 1 2024/2025 STRUCTURE A, B AND C COGS",
    //                 url: "/assets/academicCalendar/2024-2025.pdf"
    //             },
    //             {
    //                 name: "IMPORTANT DATES SEMESTER 2 2024-2025",
    //                 url: "/assets/academicCalendar/2024-2025.pdf"
    //             },
    //         ]
    //     },
    // ]
  

    const list = [
        {
            title: "Academic Year",
            subItems: data?.map((item, index) => {
                return {
                    index: index,
                    name: item?.year
                }
            })
        },
    ]

    const contents = data?.map((item, index) => {
        return (
            <AcademicsLinks key={index} link={item?.link} />
        )
    }
    )




    // const list = [
    //     {
    //         title: "Academic Year",
    //         subItems: data?.map((item, index) => {
    //             return {
    //                 index: index,
    //                 name: item.year
    //             }
    //         })
    //     },
    // ]



    // const contents = data.map((item, index) => {
    //     return (
    //         <AcademicsLinks key={index} title={item.title} description={item.description} links={item.links} />
    //     )
    // }

    // );

    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <div className="flex justify-center bg-white p-4 md:py-8 w-full">
                <div className="w-full flex flex-col gap-5 lg:px-16  ">
                    <SideMenu list={list} contents={contents}>
                        <div className="p-4 flex items-center w-full my-8">
                            <div className="flex w-full flex-col gap-3  py-10 items-center rounded-lg bg-[#02265B]">
                                <h2 className="w-auto max-w-[20ch] text-center font-bold text-white text-xl leading-tight">{`Have Questions ?`}</h2>
                                <Link to={'/contact us'} className="px-8 py-4 w-fit  bg-red-800 rounded justify-center items-center gap-4 flex">
                                    <span className="text-white  text-base font-bold capitalize flex items-center gap-3">Contact Us <FaArrowRight /></span>
                                </Link>

                            </div>
                        </div>
                    </SideMenu>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default AcademicCalendar